import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import './assets/scss/custom.scss'
import VuePrlx from 'vue-prlx'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {
  duration: 1000,
  easing: "ease"
})

Vue.use(VuePrlx);

Vue.config.productionTip = false
Vue.use(BootstrapVue)

new Vue({
  render: h => h(App),
}).$mount('#app')
